import { motion } from "framer-motion";

const Loader = ({
  size = "md",
  color = "green",
  text = "",
  fullScreen = false,
  className = "",
}) => {
  const sizeClasses = {
    xs: "w-12 h-12",
    sm: "w-16 h-16",
    md: "w-20 h-20",
    lg: "w-24 h-24",
    xl: "w-28 h-28",
  };

  const colorClasses = {
    blue: "border-blue-600",
    green: "border-green-600",
    red: "border-red-600",
    yellow: "border-yellow-600",
    purple: "border-purple-600",
    gray: "border-gray-600",
    white: "border-white",
  };

  const spinner = (
    <div className={`relative ${sizeClasses[size]} ${className}`}>
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
        className={`absolute inset-0 border-4 border-t-transparent rounded-full ${colorClasses[color]}`}
      />
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-90 backdrop-blur-sm">
        <div className="flex flex-col items-center justify-center space-y-4">
          {spinner}
          {text && (
            <p className="text-base font-medium text-gray-600">
              {text}
            </p>
          )}
        </div>
      </div>
    );
  }

  if (text) {
    return (
      <div className="flex items-center justify-center space-x-3">
        {spinner}
        <span className="text-base font-medium text-gray-600">
          {text}
        </span>
      </div>
    );
  }

  return spinner;
};

export default Loader;

